module.exports = __webpack_public_path__ + "b65c47bdcf6ae681cd06091cb78219a6.png";